export const types = {
    SET_VALUES: "SET_VALUES"
}